import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e5a4a602"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  class: "questionBox",
  id: "app"
}
const _hoisted_3 = { class: "questionContainer" }
const _hoisted_4 = { class: "title is-6" }
const _hoisted_5 = { class: "nav-dots" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "med-text text-xl focus:border-light-blue-500 focus:ring-1 focus:ring-light-blue-500 focus:outline-none text-sm text-black placeholder-gray-500 border border-gray-200 rounded-md py-2 pl-4 mx-4 sm:mx-14 md:mx-14 lg:mx-14" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "text",
    "bind:value": "{registerdata.name}",
    placeholder: "",
    class: "w-full focus:outline-none text-center"
  })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "med-text text-xl focus:border-light-blue-500 focus:ring-1 focus:ring-light-blue-500 focus:outline-none text-sm text-black placeholder-gray-500 border border-gray-200 rounded-md py-2 pl-4 mx-4 sm:mx-14 md:mx-14 lg:mx-14" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "text",
    "bind:value": "{registerdata.email}",
    placeholder: "",
    class: "w-full focus:outline-none text-center"
  })
], -1))
const _hoisted_8 = { class: "med-text text-xl focus:border-light-blue-500 focus:ring-1 focus:ring-light-blue-500 focus:outline-none text-sm text-black placeholder-gray-500 border border-gray-200 rounded-md py-2 pl-4 mx-4 sm:mx-14 md:mx-14 lg:mx-14" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "med-text text-xl focus:border-light-blue-500 focus:ring-1 focus:ring-light-blue-500 focus:outline-none text-sm text-black placeholder-gray-500 border border-gray-200 rounded-md py-2 pl-4 mx-4 sm:mx-14 md:mx-14 lg:mx-14" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "password",
    "bind:value": "{registerdata.password}",
    placeholder: "",
    class: "w-full focus:outline-none text-center"
  })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "med-text text-xl focus:border-light-blue-500 focus:ring-1 focus:ring-light-blue-500 focus:outline-none text-sm text-black placeholder-gray-500 border border-gray-200 rounded-md py-2 pl-4 mx-4 sm:mx-14 md:mx-14 lg:mx-14" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "password",
    "bind:value": "{registerdata.password_confirmation}",
    placeholder: "",
    class: "w-full focus:outline-none text-center"
  })
], -1))
const _hoisted_12 = { class: "questionFooter" }
const _hoisted_13 = {
  class: "pagination flex justify-between",
  role: "navigation",
  "aria-label": "pagination"
}
const _hoisted_14 = ["onClick", "disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AudioLyricPlayer = _resolveComponent("AudioLyricPlayer")!
  const _component_vue_final_modal = _resolveComponent("vue-final-modal")!

  return (_openBlock(), _createBlock(_component_vue_final_modal, _mergeProps(_ctx.$attrs, {
    classes: "flex justify-center items-center",
    "content-class": "relative flex flex-col max-h-full mx-4 p-4 border dark:border-gray-800 rounded bg-white dark:bg-gray-900"
  }), {
    default: _withCtx(({ close }) => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_Transition, {
            "enter-active-class": "animated zoomIn",
            "leave-active-class": "animated zoomOut",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("header", null, [
                  _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.titles_create_account), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", {
                    "data-slide": "1",
                    class: _normalizeClass(["nav-dot", {'active-dot': _ctx.currentStep == 0}])
                  }, null, 2),
                  _createElementVNode("div", {
                    "data-slide": "2",
                    class: _normalizeClass(["nav-dot", {'active-dot': _ctx.currentStep == 1}])
                  }, null, 2),
                  _createElementVNode("div", {
                    "data-slide": "3",
                    class: _normalizeClass(["nav-dot", {'active-dot': _ctx.currentStep == 2}])
                  }, null, 2),
                  _createElementVNode("div", {
                    "data-slide": "4",
                    class: _normalizeClass(["nav-dot", {'active-dot': _ctx.currentStep == 3}])
                  }, null, 2),
                  _createElementVNode("div", {
                    "data-slide": "5",
                    class: _normalizeClass(["nav-dot", {'active-dot': _ctx.currentStep == 4}])
                  }, null, 2),
                  _createElementVNode("div", {
                    "data-slide": "5",
                    class: _normalizeClass(["nav-dot", {'active-dot': _ctx.currentStep == 5}])
                  }, null, 2),
                  _createElementVNode("div", {
                    "data-slide": "5",
                    class: _normalizeClass(["nav-dot", {'active-dot': _ctx.currentStep == 6}])
                  }, null, 2),
                  _createElementVNode("div", {
                    "data-slide": "5",
                    class: _normalizeClass(["nav-dot", {'active-dot': _ctx.currentStep == 7}])
                  }, null, 2)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["page p-8 hidden", {'page_active': _ctx.currentStep == 0}])
                }, [
                  _createVNode(_component_AudioLyricPlayer, {
                    ref: "line0",
                    lyrics: _ctx.lyricsdata,
                    autoPlay: false,
                    onOnReadingLineComplete: _ctx.onReadingLineComplete,
                    onOnGameFinished: _ctx.onGameFinished
                  }, null, 8, ["lyrics", "onOnReadingLineComplete", "onOnGameFinished"])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["page p-8 hidden", {'page_active': _ctx.currentStep == 1}])
                }, [
                  _createVNode(_component_AudioLyricPlayer, {
                    ref: "line1",
                    lyrics: _ctx.lyricsdata,
                    autoPlay: false,
                    onOnReadingLineComplete: _ctx.onReadingLineComplete,
                    onOnGameFinished: _ctx.onGameFinished
                  }, null, 8, ["lyrics", "onOnReadingLineComplete", "onOnGameFinished"]),
                  _hoisted_6
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["page p-8 hidden", {'page_active': _ctx.currentStep == 2}])
                }, [
                  _createVNode(_component_AudioLyricPlayer, {
                    ref: "line2",
                    lyrics: _ctx.lyricsdata2,
                    autoPlay: false,
                    onOnReadingLineComplete: _ctx.onReadingLineComplete,
                    onOnGameFinished: _ctx.onGameFinished
                  }, null, 8, ["lyrics", "onOnReadingLineComplete", "onOnGameFinished"]),
                  _hoisted_7
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["page p-8 hidden", {'page_active': _ctx.currentStep == 3}])
                }, [
                  _createVNode(_component_AudioLyricPlayer, {
                    ref: "line3",
                    lyrics: _ctx.lyricsdata3,
                    autoPlay: false,
                    onOnReadingLineComplete: _ctx.onReadingLineComplete,
                    onOnGameFinished: _ctx.onGameFinished
                  }, null, 8, ["lyrics", "onOnReadingLineComplete", "onOnGameFinished"]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("input", {
                      type: "text",
                      "bind:value": "{registerdata.username}",
                      placeholder: "",
                      class: "w-full focus:outline-none text-center",
                      onKeyup: _cache[0] || (_cache[0] = ({ target: { value } }) => _ctx.debounce(value))
                    }, null, 32)
                  ]),
                  (_ctx.usernameExists)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, "This username already exists."))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["page p-8 hidden", {'page_active': _ctx.currentStep == 4}])
                }, [
                  _createVNode(_component_AudioLyricPlayer, {
                    ref: "line4",
                    lyrics: _ctx.lyricsdata4,
                    autoPlay: false,
                    onOnReadingLineComplete: _ctx.onReadingLineComplete,
                    onOnGameFinished: _ctx.onGameFinished
                  }, null, 8, ["lyrics", "onOnReadingLineComplete", "onOnGameFinished"]),
                  _hoisted_10
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["page p-8 hidden", {'page_active': _ctx.currentStep == 5}])
                }, [
                  _createVNode(_component_AudioLyricPlayer, {
                    ref: "line5",
                    lyrics: _ctx.lyricsdata5,
                    autoPlay: false,
                    onOnReadingLineComplete: _ctx.onReadingLineComplete,
                    onOnGameFinished: _ctx.onGameFinished
                  }, null, 8, ["lyrics", "onOnReadingLineComplete", "onOnGameFinished"]),
                  _hoisted_11
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["page p-8 hidden", {'page_active': _ctx.currentStep == 6}])
                }, [
                  _createVNode(_component_AudioLyricPlayer, {
                    ref: "line6",
                    lyrics: _ctx.lyricsdata6,
                    autoPlay: false,
                    onOnReadingLineComplete: _ctx.onReadingLineComplete,
                    onOnGameFinished: _ctx.onGameFinished
                  }, null, 8, ["lyrics", "onOnReadingLineComplete", "onOnGameFinished"])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["page p-8 hidden", {'page_active': _ctx.currentStep == 7}])
                }, [
                  _createVNode(_component_AudioLyricPlayer, {
                    ref: "line7",
                    lyrics: _ctx.lyricsdata7,
                    autoPlay: false,
                    onOnReadingLineComplete: _ctx.onReadingLineComplete,
                    onOnGameFinished: _ctx.onGameFinished
                  }, null, 8, ["lyrics", "onOnReadingLineComplete", "onOnGameFinished"])
                ], 2),
                _createElementVNode("footer", _hoisted_12, [
                  _createElementVNode("nav", _hoisted_13, [
                    (_ctx.currentStep != 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          href: "javascript:void(0)",
                          class: "btn btn-secondary button order-first",
                          onClick: ($event: any) => (_ctx.$emit('cancel', close)),
                          disabled: _ctx.currentStep == 0
                        }, _toDisplayString(_ctx.actions_goback), 9, _hoisted_14))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      href: "javascript:void(0)",
                      class: "btn button order-last",
                      onClick: _cache[1] || (_cache[1] = async (e)=> {await _ctx.next()}),
                      disabled: _ctx.currentStep == 7 && _ctx.isSigningUp
                    }, [
                      (_ctx.isSigningUp)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.actions_continue), 1)
                          ], 64))
                    ], 8, _hoisted_15)
                  ])
                ])
              ])
            ]),
            _: 2
          }, 1024)
        ])
      ])
    ]),
    _: 1
  }, 16))
}